import { AditivoContrato } from "@/types/licitacoes/aditivo-contrato/aditivo-contrato";
import { AditivoContratoResumido } from "@/types/licitacoes/aditivo-contrato/aditivo-contrato-resumido";
import { Service } from "../mainService";

const aditivosContratoService = {
  buscarAditivo,
  adicionarAditivo,
  editarAditivo,
  buscarAditivos,
  removerAditivo,
  listarContratos,
  listarTiposAditivo,
  listarNaturezasAjuste,
  baixarAnexo,
  listarLogs,
  importarXml,
  baixarRelatorioDeInconsistencias,
  filtrarAditivos,
};

async function buscarAditivos(page, pageSize) {
  try {
    const url =
      process.env.VUE_APP_LICITACOES_API +
      "/aditivoContrato/listar?page=" +
      page +
      "&pageSize=" +
      pageSize;
    const response = await Service.$http.get(url);
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function buscarAditivo(id: string) {
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_LICITACOES_API + "/aditivoContrato/buscar/" + id
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function baixarAnexo(id) {
  try {
    const response = await Service.$http.get(
      process.env.VUE_APP_LICITACOES_API + "/aditivoContrato/baixaranexo/" + id,
      { responseType: "blob" }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function listarLogs(id: number) {
  try {
    const url =
      process.env.VUE_APP_LICITACOES_API + "/aditivoContrato/listarLogs/" + id;
    const response = await Service.$http.get(url);
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function listarContratos() {
  try {
    const url =
      process.env.VUE_APP_LICITACOES_API + "/aditivoContrato/listarContratos/";
    const response = await Service.$http.get(url);
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function listarTiposAditivo() {
  try {
    const url =
      process.env.VUE_APP_LICITACOES_API +
      "/aditivoContrato/listarTiposAditivo/";
    const response = await Service.$http.get(url);
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function listarNaturezasAjuste() {
  try {
    const url =
      process.env.VUE_APP_LICITACOES_API +
      "/aditivoContrato/listarNaturezasAjuste/";
    const response = await Service.$http.get(url);
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function adicionarAditivo(infoAditivo: AditivoContrato, arquivo: any) {
  try {
    const data = new FormData();
    data.append("IdContrato", infoAditivo.IdContrato.toString());
    data.append("IdNaturezaAjuste", infoAditivo.IdNaturezaAjuste.toString());
    data.append(
      "IdTipoTermoAditivo",
      infoAditivo.IdTipoTermoAditivo.toString()
    );
    data.append("NrAditivo", infoAditivo.NrAditivoContrato.toString());
    data.append("AnoAditivo", infoAditivo.NrAnoAditivoContrato.toString());
    data.append("DeJustificativa", infoAditivo.DeJustificativaAditivo);
    if (infoAditivo.DtAnulacaoAditivo)
      data.append("DtAnulacao", infoAditivo.DtAnulacaoAditivo.toISOString());
    if (infoAditivo.DeMotivoAnulacaoAditivo)
      data.append(
        "DeMotivoAnulacao",
        infoAditivo.DeMotivoAnulacaoAditivo.toString()
      );
    if (infoAditivo.DtInicioVigenciaAditivo)
      data.append(
        "DtInicioVigencia",
        infoAditivo.DtInicioVigenciaAditivo.toISOString()
      );
    if (infoAditivo.DtFimVigenciaAditivo)
      data.append(
        "DtFimVigencia",
        infoAditivo.DtFimVigenciaAditivo.toISOString()
      );
    if (infoAditivo.VlAditivoContrato)
      data.append("VlAditivo", infoAditivo.VlAditivoContrato.toString());
    data.append("DtAssinatura", infoAditivo.DtAssinaturaAditivo.toISOString());
    data.append("DtPublicacao", infoAditivo.DtPublicacaoAditivo.toISOString());
    data.append("ArquivoTextoAditivo", arquivo);
    if (infoAditivo.CdCpfCnpjParticipante)
      data.append("CdCpfCnpjParticipante", infoAditivo.CdCpfCnpjParticipante);
    if (infoAditivo.NmParticipante)
      data.append("NmParticipante", infoAditivo.NmParticipante);
    if (infoAditivo.DeJustificativaAlteracaoSubjetiva)
      data.append(
        "DeJustificativaAlteracaoSubjetiva",
        infoAditivo.DeJustificativaAlteracaoSubjetiva
      );

    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API + "/aditivoContrato/adicionar",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function editarAditivo(infoAditivo: AditivoContrato, arquivo: any) {
  try {
    const data = new FormData();
    data.append("IdContrato", infoAditivo.IdContrato.toString());
    data.append("IdNaturezaAjuste", infoAditivo.IdNaturezaAjuste.toString());
    data.append(
      "IdTipoTermoAditivo",
      infoAditivo.IdTipoTermoAditivo.toString()
    );
    data.append("NrAditivo", infoAditivo.NrAditivoContrato.toString());
    data.append("AnoAditivo", infoAditivo.NrAnoAditivoContrato.toString());
    data.append("DeJustificativa", infoAditivo.DeJustificativaAditivo);
    if (infoAditivo.DtAnulacaoAditivo)
      data.append("DtAnulacao", infoAditivo.DtAnulacaoAditivo.toISOString());
    if (infoAditivo.DeMotivoAnulacaoAditivo)
      data.append(
        "DeMotivoAnulacao",
        infoAditivo.DeMotivoAnulacaoAditivo.toString()
      );
    if (infoAditivo.DtInicioVigenciaAditivo)
      data.append(
        "DtInicioVigencia",
        infoAditivo.DtInicioVigenciaAditivo.toISOString()
      );
    if (infoAditivo.DtFimVigenciaAditivo)
      data.append(
        "DtFimVigencia",
        infoAditivo.DtFimVigenciaAditivo.toISOString()
      );
    if (infoAditivo.VlAditivoContrato)
      data.append("VlAditivo", infoAditivo.VlAditivoContrato.toString());
    data.append("DtAssinatura", infoAditivo.DtAssinaturaAditivo.toISOString());
    data.append("DtPublicacao", infoAditivo.DtPublicacaoAditivo.toISOString());
    if (arquivo) data.append("ArquivoTextoAditivo", arquivo);
    if (infoAditivo.CdCpfCnpjParticipante)
      data.append("CdCpfCnpjParticipante", infoAditivo.CdCpfCnpjParticipante);
    if (infoAditivo.NmParticipante)
      data.append("NmParticipante", infoAditivo.NmParticipante);
    if (infoAditivo.DeJustificativaAlteracaoSubjetiva)
      data.append(
        "DeJustificativaAlteracaoSubjetiva",
        infoAditivo.DeJustificativaAlteracaoSubjetiva
      );

    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API +
        "/aditivoContrato/editar/" +
        infoAditivo.IdAditivoContrato,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function importarXml(arquivo) {
  try {
    const data = new FormData();
    data.append("zipFile", arquivo);
    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API + "/aditivoContrato/importar/xml",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function baixarRelatorioDeInconsistencias(data) {
  try {
    const response = await Service.$http.post(
      process.env.VUE_APP_LICITACOES_API +
        "/aditivoContrato/relatoriodeinconsistencias",
      data,
      { responseType: "blob" }
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function removerAditivo(id: number) {
  try {
    const response = await Service.$http.delete(
      process.env.VUE_APP_LICITACOES_API + "/aditivoContrato/remover/" + id
    );
    return response;
  } catch (e: any) {
    return e.response;
  }
}

async function filtrarAditivos(
  page,
  pageSize,
  numero,
  ano,
  contrato,
  naturezaAjuste,
  tipoAditivo
) {
  try {
    let url =
      process.env.VUE_APP_LICITACOES_API +
      `/aditivoContrato/filtrarAditivos?page=${page}&pageSize=${pageSize}`;
    if (numero != null) url += `&filtroNumero=${numero}`;
    if (ano != null) url += `&filtroAno=${ano}`;
    if (contrato != null) url += `&filtroContrato=${contrato}`;
    if (naturezaAjuste != null)
      url += `&filtroNaturezaAjuste=${naturezaAjuste}`;
    if (tipoAditivo != null) url += `&filtroTipoAditivo=${tipoAditivo}`;
    const response = await Service.$http.get(url);
    return response;
  } catch (e: any) {
    return e.response;
  }
}

export default aditivosContratoService;
